import { gameRunningStatuses } from 'config/gameRunningStatuses';
import getLoginUserNonQualifyTypeAfterEntry from '../getLoginUserNonQualifyTypeAfterEntry';
import { size } from 'lodash';

export default async function getUserLoginStateAfterEntry(state, mergeAndDispatchState) {
    const {
        userLoginState: { isLogin, notQualifiedType, notQualifiedErrInfo },
        promoState: {
            gameRunningStatus,
            periodPlayMatchedInfo: { matchedInfo: { match: isInPlayTimePeriod } = {} } = {}
        }
    } = state;

    const isPromoPlayableOnTime =
        gameRunningStatus === gameRunningStatuses.RUNNING && isInPlayTimePeriod;
    const resp =
        isLogin && isPromoPlayableOnTime ? await getLoginUserNonQualifyTypeAfterEntry(state) : {};

    mergeAndDispatchState(!notQualifiedType && !Boolean(size(notQualifiedErrInfo)) ? resp : {});
}
